<template>
  <section class="country-map">
    <div
      class="country-map__map"
      :style="`background-image: url(${require(`../assets/images/${data.image}.png`)})`"
    >
      <ul class="country-map__map--cities">
        <li
          v-for="(city, i) in data.locations"
          :key="`city_${i}`"
          :style="`top: ${city.top}; left: ${city.left}`"
          :class="chosenCity === i && 'chosen'"
          @click="updateChosenCity(i)"
        >
          {{ city.city }}
        </li>
      </ul>
    </div>
    <div class="country-map__carousel">
      <h3 class="country-map__carousel--title">
        <img
          src="../assets/images/white-arrow-left.svg"
          alt="arrow-left"
          @click="
            chosenCity !== 0
              ? (chosenCity -= 1)
              : (chosenCity = data.locations.length - 1)
          "
        />{{ data.locations[chosenCity].city
        }}<img
          src="../assets/images/white-arrow-right.svg"
          alt="arrow-right"
          @click="
            chosenCity !== data.locations.length - 1
              ? (chosenCity += 1)
              : (chosenCity = 0)
          "
        />
      </h3>
      <food-carousel
        :items="data.locations[chosenCity].cuisines"
        :for-maps="true"
      />
    </div>
  </section>
</template>

<script>
import FoodCarousel from './FoodCarousel.vue'
export default {
  name: 'CountryMap',
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  components: { FoodCarousel },
  data() {
    return {
      chosenCity: 0,
    }
  },
  methods: {
    updateChosenCity(i) {
      this.chosenCity = i
    },
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.country-map {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  &__map {
    background-repeat: no-repeat;
    width: 60%;
    height: 1000px;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 1;
    background-size: contain;
    position: relative;
    @media (max-width: $tablet) {
      display: none;
    }
    @media (max-width: $desktop) {
      width: 70%;
    }
    &--cities {
      list-style-type: none;
      li {
        position: fixed;
        border-radius: 30px;
        z-index: 2;
        padding: 5px;
        min-width: 150px;
        text-align: center;
        cursor: pointer;
        background-color: var(--color-mozzarella-1);
        color: var(--color-charcoal-1);
        border: 2px solid var(--color-charcoal-1);
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
  &__carousel {
    background-color: var(--color-white-1);
    border-top: 50px solid var(--color-orange-1);
    border-radius: 30px;
    padding: 60px 20px;
    width: 40%;
    margin: 0 5%;
    display: inline-table;
    @media (max-width: $tablet) {
      width: 90% !important;
      margin: 50px 0;
      padding: 20px;
    }
    @media (max-width: $desktop) {
      width: 30%;
    }
    &--title {
      text-align: center;
      font-size: 22px;
      color: var(--color-white-1);
      margin-top: -105px;
      margin-bottom: 50px;
      display: flex;
      justify-content: space-between;
      @media (max-width: $tablet) {
        margin-top: -85px;
        padding-top: 20px;
        margin-bottom: 30px;
        font-size: 18px;
      }
      @media (max-width: $desktop) {
        font-size: 20px;
      }
      img {
        padding: 0 20px;
      }
    }
  }
}
.chosen {
  background-color: var(--color-orange-1) !important;
  color: var(--color-white-1) !important;
  border: 2px solid var(--color-orange-1) !important;
}
</style>